// auto-generated by Typewriter template _enums.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\DispatchDashboardController.cs
export enum DispatchDashboardTab { 
    New = 0,
    Movements = 1,
    Search = 2,
    BillingWorklist = 3
}

export const DispatchDashboardTabDisplayName : { [val : number] : string } = { 
    0: 'New',
    1: 'Movements',
    2: 'Search',
    3: 'BillingWorklist'
}

export const DispatchDashboardTabs : { Id : DispatchDashboardTab, Name : string }[] = [ 
    { Id: DispatchDashboardTab.New, Name: 'New' },
    { Id: DispatchDashboardTab.Movements, Name: 'Movements' },
    { Id: DispatchDashboardTab.Search, Name: 'Search' },
    { Id: DispatchDashboardTab.BillingWorklist, Name: 'BillingWorklist' }
]



// WEBPACK FOOTER //
// ./server/enums/DispatchDashboardTab.ts